/**
 * @generated SignedSource<<c4dbb5fe4945f39faca7d7c0859280e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CateringOptionName_cateringOption$data = {
  readonly etgKey: string | null;
  readonly name: string | null;
  readonly " $fragmentType": "CateringOptionName_cateringOption";
};
export type CateringOptionName_cateringOption$key = {
  readonly " $data"?: CateringOptionName_cateringOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"CateringOptionName_cateringOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CateringOptionName_cateringOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "etgKey",
      "storageKey": null
    }
  ],
  "type": "CateringOption",
  "abstractKey": null
};

(node as any).hash = "ff19663747e7c0b055095f3b193b51e6";

export default node;
